<script>
import axios from '@/utils/axios';
import { getSiteInspectorDropdown } from '@/utils/site-inspector';
import { pincodeWiseAddress } from '@/utils/admin';
import { useCountryStore } from '@/stores/useCountryStore';
import { useStatesStore } from '@/stores/useStatesStore'

export default {
  emits: ['updated'],
  data() {
    return {
      isEdit: false,
      viewMode: false,
      editId: null,
      deleteRow: null,
      submitting: false,
      editStatus: '',
      errors: {},
      form: {
        customer_id: '',
        user_id: '',
        order_number: '',
        name: '',
        mobile: '',
        address: '',
        file_number: '',
        order_date: '',
        dispatch_date: '',
        windows_quantity: '',
        glass_status: '',
        remark: '',
        delivery_status: 'ready_for_dispatch',
        site_inspector_id: '',
        unloading_status: 'normal',
        special_remark: ''
      },
      salesExecutives: [],
      groups: [],
      groupLevels: [],
      finalGroupId: '',
      loadingGroups: false,
      groupPath: [],
      leafPath: '', 
      siteInspectors: [],
      countries: [],
      states: [],
      country: null,
      state: null,
      city: '',
      pincode: '',
      installerForm: {
        id: null,
        installation_person_id: '',
      },
      installationPersons: [],
      statusForm: {
        id: null,
        delivery_status: 'ready_for_dispatch',
        current_status: '',           
        transport_person_name: '',    
        transport_phone_number: '',   
        transport_vehicle_number: '',
      },
      submittingStatus: false,
    };
  },

  mounted() {
    
    this.fetchSiteInspectors();
    this.loadInstallationPersons();
    this.fetchSalesExecutives();
     this.getGroups(); 
  },

  methods: {

async getCountries() {
  const store = useCountryStore()
  this.countries = await store.loadCountries()
  if (!this.editId) {
    this.country = this.countries.find(c => c.name === this.clientAdmin?.company?.country) || null
  }
  if (this.country?.id) {
    this.getStates(this.country.id)
  }
},

onCountrySelect(country) {
  this.getStates(country?.id)
},

async getStates(country_id) {
  this.state = null
  this.states = []
  if (country_id) {
    const store = useStatesStore()
    this.states = await store.loadStates(country_id)
    this.state = this.states.find(s => s.name === this.clientAdmin?.company?.state)
  }
},

checkPincode() {
  if (this.pincode.length < 6) {
    this.errors.pincode = ["The pincode field must be 6 digits."]
  } else {
    delete this.errors.pincode
    clearTimeout(this.pincodeTimeout)
    this.pincodeTimeout = setTimeout(() => {
      this.addressByPincode()
    }, 500)
  }
},

async addressByPincode() {
  try {
    const response = await pincodeWiseAddress(this.pincode)
    const data = response.data.data
    const new_country = data?.country 
      ? this.countries.find(c => c.name === data.country) 
      : this.country
    this.city = data?.city || this.city
    if (new_country && new_country?.id !== this.country?.id) {
      this.country = new_country
      await this.getStates(new_country.id)
      this.state = data?.state 
        ? this.states.find(s => s.name === data.state) 
        : this.state
    } else if (data?.state) {
      this.state = this.states.find(s => s.name === data.state)
    }
  } catch (error) {
    console.log('Pincode lookup failed:', error.message)
  }
},


async getGroups() {
  this.loadingGroups = true;
  try {
    this.groupLevels = [];
    this.groupPath = [];
    // this.finalGroupId = '';
    // this.leafPath = '';
    await this.loadLevelGroups(1);
  } catch (error) {
    console.error('Groups error:', error);
  } finally {
    this.loadingGroups = false;
  }
},

async loadLevelGroups(level) {
  this.loadingGroups = true;
  try {
    const parentId = this.getParentIdForLevel(level - 1);
    const parentPath = parentId ? `/${parentId}` : '';
    const response = await axios.get(`/item-groups/children${parentPath}`);
    const apiData = response.data.data;

    if (this.groupLevels.length < level) {
      while (this.groupLevels.length < level) {
        this.groupLevels.push([]);
      }
    }

    this.groupLevels[level - 1] = apiData.map(group => ({
      id: parseInt(group.id),
      name: group.name,
      selected: false
    }));

    this.updateGroupPath();
  } catch (e) {
    console.error('Load level error:', e);
    if (this.groupLevels[level - 1]) {
      this.groupLevels[level - 1] = [];
    }
  } finally {
    this.loadingGroups = false;
  }
},

getParentIdForLevel(level) {
  if (level === 0) return null;
  const previousLevel = this.groupLevels[level - 1];
  if (!previousLevel || previousLevel.length === 0) return null;
  const selectedGroup = previousLevel.find(group => group.selected);
  return selectedGroup ? selectedGroup.id : null;
},

async onGroupLevelChange(level, event) {
  const selectedId = event.target.value;

  this.groupLevels.forEach(lvl => {
    if (lvl) {
      lvl.forEach(group => { group.selected = false; });
    }
  });

  // Remove levels after current
  this.groupLevels.splice(level + 1);

  if (selectedId && this.groupLevels[level]) {
    const selectedGroup = this.groupLevels[level].find(group => group.id.toString() === selectedId);
    if (selectedGroup) {
      selectedGroup.selected = true;
      this.finalGroupId = selectedGroup.id;
      await this.loadLevelGroups(level + 2);
    }
  } else {
    this.finalGroupId = '';
  }
  this.updateGroupPath();
},

updateGroupPath() {
  this.groupPath = [];
  this.groupLevels.forEach(level => {
    if (level) {
      const selected = level.find(group => group.selected);
      if (selected) {
        this.groupPath.push(selected);
      }
    }
  });
  if (this.groupPath.length > 0) {
    this.finalGroupId = this.groupPath[this.groupPath.length - 1].id;
  }
},


    async loadInstallationPersons() {
  try {
    const response = await axios.get('/installation-persons/dropdown');
    this.installationPersons = response.data.data;
  } catch (error) {
    console.log(error.message);
  }
},

openAssignInstaller(row) {
  this.installerForm = {
    id: row.id,
    installation_person_id: '',
  };
  this.errors = {};
},

async submitAssignInstaller() {
  this.errors = {};
  try {
    const response = await axios.patch(`/customer-dispatches/${this.installerForm.id}/assign-to-installer`, {
      installation_person_id: this.installerForm.installation_person_id
    });
    this.$swalToast(response.data.message);
    this.$closeModal('assign_installer_modal');
    this.$emit('updated');
  } catch (error) {
    if (error.type == 'validation') {
      this.errors = error.errors;
    } else {
      this.$swalToast(error.message, 'error');
    }
  }
},

    openCreateForCustomer(customerId) {
    this.resetForm();
    this.form.customer_id = customerId;
     this.getGroups();
     this.getCountries();
    // if(!this.users.length) this.fetchUsers();
},

    resetForm() {
  this.isEdit = false;
  this.viewMode = false;
  this.editId = null;
  this.editStatus = '';
  this.errors = {};
  this.groupLevels = [];
  this.groupPath = [];
  this.finalGroupId = '';
  this.country = null;
  this.state = null;
  this.city = '';
  this.pincode = '';
  this.form = {
    customer_id: '',
    user_id: '',
    order_number: '',
    name: '',
    mobile: '',
    address: '',
    file_number: '',
    order_date: '',
    dispatch_date: '',
    windows_quantity: '',
    glass_status: '',
    remark: '',
    delivery_status: 'ready_for_dispatch',
    site_inspector_id: '',
    unloading_status: 'normal',
    special_remark: '',
    transport_person_name: '',     
    transport_phone_number: '',
    transport_vehicle_number: '',
  };
},

// async fetchUsers() {
//   try {
//     const response = await axios.get('/users/all-users');
//     this.users = response.data.data;
//   } catch (error) {
//     console.log('Failed to load users:', error.message);
//   }
// },

async fetchSalesExecutives() {
  try {
    const response = await axios.get('/sales-executives/dropdown');
    this.salesExecutives = response.data.data;
  } catch (error) {
    console.log('Failed to load sales executives:', error.message);
  }
},

    async fetchSiteInspectors() {
  try {
    const res = await getSiteInspectorDropdown();
    this.siteInspectors = res?.data?.data || [];
  } catch (error) {
    console.log('Failed to load site inspectors:', error.message);
  }
},

    openCreate() {
  this.resetForm();
   this.getGroups();
   this.getCountries();
  // if(!this.users.length) this.fetchUsers();
},

    async openEdit(id) {
      this.resetForm();
      this.isEdit = true;
      this.editId = id;
      // if(!this.users.length) this.fetchUsers();
      try {
        const response = await axios.get(`/customer-dispatches/${id}`);
        const d = response.data.data;
        this.form = {
          customer_id: d.customer_id,
          user_id: d.user_id,
          name: d.name,
          mobile: d.mobile,
          address: d.address,
          file_number: d.file_number,
          order_number: d.order_number || '',
          order_date: d.order_date,
          dispatch_date: d.dispatch_date,
          windows_quantity: d.windows_quantity,
          glass_status: d.glass_status || '',
          remark: d.remark || '',
          delivery_status: d.delivery_status,
          site_inspector_id: d.site_inspector_id || '',
          unloading_status: d.unloading_status || 'normal',
          special_remark: d.special_remark || '',
        };
        this.editStatus = d.delivery_status || '';
        this.finalGroupId = d.item_group_id || '';
        this.leafPath = d.leaf_path || '';
        this.city = d.city || '';
        this.pincode = d.pincode || '';
        await this.getGroups();
        const store = useCountryStore()
        this.countries = await store.loadCountries()
        this.country = this.countries.find(c => c.name === d.country) || null;
        if (this.country?.id) {
          const statesStore = useStatesStore()
          this.states = await statesStore.loadStates(this.country.id)
          this.state = this.states.find(s => s.name === d.state) || null;
        }
      } catch (error) {
        this.$swalToast(error.message, 'error');
      }
    },

    async openView(id) {
      this.resetForm();
      this.isEdit = true;
      this.editId = id;
      //  if(!this.users.length) this.fetchUsers();
      try {
        const response = await axios.get(`/customer-dispatches/${id}`);
        const d = response.data.data;
        this.form = {
          user_id: d.user_id,
          name: d.name,
          mobile: d.mobile,
          address: d.address,
          file_number: d.file_number,
          order_number: d.order_number || '',
          order_date: d.order_date,
          dispatch_date: d.dispatch_date,
          windows_quantity: d.windows_quantity,
          glass_status: d.glass_status || '',
          remark: d.remark || '',
          delivery_status: d.delivery_status,
          site_inspector_id: d.site_inspector_id || '',
          unloading_status: d.unloading_status || 'normal',
          special_remark: d.special_remark || '',
          transport_person_name: d.transport_person_name || '',     
          transport_phone_number: d.transport_phone_number || '',   
          transport_vehicle_number: d.transport_vehicle_number || '', 
        };
        this.viewMode = true;
        this.finalGroupId = d.item_group_id || '';
        this.leafPath = d.leaf_path || '';
        this.city = d.city || '';
        this.pincode = d.pincode || '';
        const store = useCountryStore()
        this.countries = await store.loadCountries()
        this.country = this.countries.find(c => c.name === d.country) || null;
        if (this.country?.id) {
          const statesStore = useStatesStore()
          this.states = await statesStore.loadStates(this.country.id)
          this.state = this.states.find(s => s.name === d.state) || null;
        }
      } catch (error) {
        this.$swalToast(error.message, 'error');
      }
    },

    openDelete(row) {
      this.deleteRow = row;
    },

    async submitForm() {
      if (this.submitting) return;
      this.submitting = true;
      this.errors = {};
      try {
        const payload = { ...this.form };
            if (this.finalGroupId) {
            payload.item_group_id = this.finalGroupId;
          }
          payload.city = this.city;
          payload.pincode = this.pincode;
          payload.country = this.country?.name || '';
          payload.state = this.state?.name || '';
        if (this.isEdit) {
          await axios.put(`/customer-dispatches/${this.editId}`, payload);
          this.$swalToast('Dispatch updated successfully', 'success');
        } else {
          await axios.post('/customer-dispatches', payload);
          this.$swalToast('Dispatch created successfully', 'success');
        }
        this.$closeModal('customer_dispatch_modal');
        this.$emit('updated');
      } catch (error) {
  if (error.type == 'validation') {
    this.errors = error.errors;
  } else {
    this.$swalToast(error.message, 'error');
  }
      } finally {
        this.submitting = false;
      }
    },

    async deleteDispatch() {
      if (!this.deleteRow) return;
      try {
        await axios.delete(`/customer-dispatches/${this.deleteRow.id}`);
        this.$swalToast('Dispatch deleted successfully', 'success');
        this.$closeModal('customer_dispatch_delete_modal');
        this.deleteRow = null;
        this.$emit('updated');
      } catch (error) {
        this.$swalToast(error.message, 'error');
      }
    },

    openStatusModal(row) {
  this.statusForm = {
    id: row.id,
    delivery_status: '',
    current_status: row.delivery_status, 
    transport_person_name: '',
    transport_phone_number: '',
    transport_vehicle_number: '',
  };
  this.submittingStatus = false;
},

async submitStatus() {
  if (this.submittingStatus) return;
  this.submittingStatus = true;
  this.errors = {};
  try {
    const payload = {
      delivery_status: this.statusForm.delivery_status,
    };

    // sirf dispatched hone par transport fields add karo
    if (this.statusForm.delivery_status === 'dispatched') {
      payload.transport_person_name   = this.statusForm.transport_person_name;
      payload.transport_phone_number  = this.statusForm.transport_phone_number;
      payload.transport_vehicle_number = this.statusForm.transport_vehicle_number;
    }

    await axios.patch(`/customer-dispatches/${this.statusForm.id}/status`, payload);
    this.$swalToast('Status updated successfully', 'success');
    this.$closeModal('customer_dispatch_status_modal');
    this.$emit('updated');
  } catch (error) {
    if (error.type == 'validation') {
      this.errors = error.errors;
    } else {
      this.$swalToast(error.message, 'error');
    }
  } finally {
    this.submittingStatus = false;
  }
},

  },
};
</script>

<template>

  <!-- Create/Edit/View Modal -->
<div class="modal fade" id="customer_dispatch_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ viewMode ? 'View' : (isEdit ? 'Edit' : 'Add') }} Customer Dispatch</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
        <div class="row">

          <!-- Assigned User -->
          <div class="col-md-6 mb-3">
            <label class="form-label">Assigned User <span v-if="!viewMode" class="text-danger">*</span></label>
            <select v-if="!viewMode" class="form-select" :class="{ 'is-invalid': errors.user_id }" v-model="form.user_id" :disabled="editStatus === 'approval_pending' || editStatus === 'pending'">
              <option value="">Select Sales Executive</option>
              <option v-for="se in salesExecutives" :key="se.id" :value="se.user_id">{{ se.user?.name }}</option>
            </select>
            <p v-else class="form-control-plaintext mb-0">{{ salesExecutives.find(se => se.user_id === form.user_id)?.user?.name || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.user_id">{{ errors.user_id[0] }}</div>
          </div>

          <!-- Site Inspector -->
          <div class="col-md-6 mb-3">
            <label class="form-label">Site Inspector <span v-if="!viewMode" class="text-danger">*</span></label>
            <select v-if="!viewMode" class="form-select" :class="{ 'is-invalid': errors.site_inspector_id }" v-model="form.site_inspector_id">
              <option value="">Select Site Inspector</option>
              <option v-for="si in siteInspectors" :key="si.id" :value="si.id">{{ si.user?.name }}</option>
            </select>
            <p v-else class="form-control-plaintext mb-0">{{ siteInspectors.find(si => si.id === form.site_inspector_id)?.user?.name || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.site_inspector_id">{{ errors.site_inspector_id[0] }}</div>
          </div>

          <!-- <div class="col-md-6 mb-3">
            <label class="form-label">Customer Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" :class="{ 'is-invalid': errors.name }" v-model="form.name" placeholder="Enter customer name" :disabled="viewMode" />
            <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
          </div> -->

          <!-- <div class="col-md-6 mb-3">
            <label class="form-label">Mobile <span class="text-danger">*</span></label>
            <input type="text" class="form-control" :class="{ 'is-invalid': errors.mobile }" v-model="form.mobile" placeholder="Enter mobile number" :disabled="viewMode" />
            <div class="invalid-feedback" v-if="errors.mobile">{{ errors.mobile[0] }}</div>
          </div> -->

          <!-- File Number -->
          <div class="col-md-6 mb-3">
            <label class="form-label">File Number <span v-if="!viewMode" class="text-danger">*</span></label>
            <input v-if="!viewMode" type="text" class="form-control" :class="{ 'is-invalid': errors.file_number }" v-model="form.file_number" placeholder="Enter file number" />
            <p v-else class="form-control-plaintext mb-0">{{ form.file_number || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.file_number">{{ errors.file_number[0] }}</div>
          </div>

          <!-- Order Number -->
          <div class="col-md-6 mb-3">
            <label class="form-label">Order Number <span v-if="!viewMode" class="text-danger">*</span></label>
            <input v-if="!viewMode" type="text" class="form-control" 
              :class="{ 'is-invalid': errors.order_number }" 
              v-model="form.order_number" 
              placeholder="Enter order number" />
            <p v-else class="form-control-plaintext mb-0">{{ form.order_number || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.order_number">{{ errors.order_number[0] }}</div>
          </div>

          <!-- <div class="col-md-12 mb-3">
            <label class="form-label">Address</label>
            <input type="text" class="form-control" :class="{ 'is-invalid': errors.address }" v-model="form.address" placeholder="Enter address" :disabled="viewMode" />
            <div class="invalid-feedback" v-if="errors.address">{{ errors.address[0] }}</div>
          </div> -->

          <!-- Order Date -->
          <div class="col-md-6 mb-3">
            <label class="form-label">Order Date <span v-if="!viewMode" class="text-danger">*</span></label>
            <input v-if="!viewMode" type="date" class="form-control" :class="{ 'is-invalid': errors.order_date }" v-model="form.order_date" :disabled="editStatus === 'approval_pending' || editStatus === 'pending'" />
            <p v-else class="form-control-plaintext mb-0">{{ form.order_date || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.order_date">{{ errors.order_date[0] }}</div>
          </div>

          <!-- Dispatch Date -->
          <div class="col-md-6 mb-3">
            <label class="form-label">Dispatch Date <span v-if="!viewMode" class="text-danger">*</span></label>
            <input v-if="!viewMode" type="date" class="form-control" :class="{ 'is-invalid': errors.dispatch_date }" v-model="form.dispatch_date" :disabled="editStatus === 'approval_pending' || editStatus === 'pending'" />
            <p v-else class="form-control-plaintext mb-0">{{ form.dispatch_date || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.dispatch_date">{{ errors.dispatch_date[0] }}</div>
          </div>

          <!-- Windows Quantity -->
          <div class="col-md-6 mb-3">
            <label class="form-label">Windows Quantity <span v-if="!viewMode" class="text-danger">*</span></label>
            <input v-if="!viewMode" type="number" class="form-control" :class="{ 'is-invalid': errors.windows_quantity }" v-model="form.windows_quantity" placeholder="Enter quantity" min="0" />
            <p v-else class="form-control-plaintext mb-0">{{ form.windows_quantity || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.windows_quantity">{{ errors.windows_quantity[0] }}</div>
          </div>

          <!-- Glass Status -->
          <div class="col-md-6 mb-3">
            <label class="form-label">Glass Status</label>
            <input v-if="!viewMode" type="text" class="form-control" :class="{ 'is-invalid': errors.glass_status }" v-model="form.glass_status" placeholder="Enter glass status" />
            <p v-else class="form-control-plaintext mb-0">{{ form.glass_status || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.glass_status">{{ errors.glass_status[0] }}</div>
          </div>

          <!-- Unloading Status -->
          <div class="col-md-6 mb-3">
            <label class="form-label">Unloading Status</label>
            <select v-if="!viewMode" class="form-select" :class="{ 'is-invalid': errors.unloading_status }" v-model="form.unloading_status">
              <option value="normal">Normal</option>
              <option value="special">Special</option>
            </select>
            <p v-else class="form-control-plaintext mb-0">
              <span class="badge" :class="form.unloading_status === 'special' ? 'bg-warning text-dark' : 'bg-light text-dark'">
                {{ form.unloading_status === 'special' ? 'Special' : 'Normal' }}
              </span>
            </p>
            <div class="invalid-feedback" v-if="errors.unloading_status">{{ errors.unloading_status[0] }}</div>
          </div>

          <!-- Special Remark (conditional) -->
          <div class="col-md-12 mb-3" v-if="form.unloading_status === 'special'">
            <label class="form-label">Special Remark</label>
            <input v-if="!viewMode" type="text" class="form-control" :class="{ 'is-invalid': errors.special_remark }" v-model="form.special_remark" placeholder="Enter special remark" />
            <p v-else class="form-control-plaintext mb-0">{{ form.special_remark || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.special_remark">{{ errors.special_remark[0] }}</div>
          </div>

          <!-- Item Group (multi-level) -->
          <div class="col-md-12 mb-3" v-if="groupLevels.some(l => l.length > 0) || leafPath">
            <label class="form-label">Item Group <span v-if="!viewMode" class="text-danger">*</span></label>

            <div v-if="leafPath && !viewMode" class="mb-2">
              <span class="badge bg-light text-dark border" style="font-size:12px;">
                <i class="ti ti-folder-open me-1"></i>{{ leafPath }}
              </span>
            </div>

            <template v-if="!viewMode">
              <div v-for="(levelGroups, levelIndex) in groupLevels" :key="`level-${levelIndex}`">
                <div v-if="levelGroups.length > 0" class="mb-2">
                  <small class="text-muted d-block mb-1" style="font-size:11px;font-weight:600;">
                    {{ levelIndex === 0 ? 'Main Category' : `Sub Category Level ${levelIndex + 1}` }}
                  </small>
                  <select class="form-select" @change="onGroupLevelChange(levelIndex, $event)" :disabled="loadingGroups">
                    <option value="">— Select Category —</option>
                    <option v-for="group in levelGroups" :key="group.id" :value="group.id" :selected="group.selected">{{ group.name }}</option>
                  </select>
                </div>
              </div>
              <div v-if="loadingGroups" class="text-muted" style="font-size:11px;">
                <i class="ti ti-loader-2 me-1"></i>Loading categories...
              </div>
            </template>

            <p v-else class="form-control-plaintext mb-0">{{ leafPath || '-' }}</p>

            <div class="invalid-feedback d-block" v-if="errors.item_group_id">{{ errors.item_group_id[0] }}</div>
          </div>

          <!-- Remark -->
          <div class="col-md-12 mb-3">
            <label class="form-label">Remark</label>
            <textarea v-if="!viewMode" class="form-control" :class="{ 'is-invalid': errors.remark }" v-model="form.remark" rows="2" placeholder="Enter remark"></textarea>
            <p v-else class="form-control-plaintext mb-0">{{ form.remark || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.remark">{{ errors.remark[0] }}</div>
          </div>

          <!-- Address -->
          <div class="col-md-12 mb-3">
            <label class="form-label">Address <span v-if="!viewMode" class="text-danger">*</span></label>
            <input v-if="!viewMode" type="text" class="form-control" :class="{ 'is-invalid': errors.address }" v-model="form.address" placeholder="Enter address" />
            <p v-else class="form-control-plaintext mb-0">{{ form.address || '-' }}</p>
            <div class="invalid-feedback" v-if="errors.address">{{ errors.address[0] }}</div>
          </div>


          <!-- Pincode -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Pincode <span v-if="!viewMode" class="text-danger">*</span></label>
              <input v-if="!viewMode" type="text" class="form-control" :class="{ 'is-invalid': errors.pincode }" v-model="pincode" maxlength="6" @keyup="checkPincode" placeholder="Enter pincode" />
              <p v-else class="form-control-plaintext mb-0">{{ pincode || '-' }}</p>
              <div class="invalid-feedback" v-if="errors.pincode">{{ errors.pincode[0] }}</div>
            </div>

            <!-- City -->
            <div class="col-md-3 mb-3">
              <label class="form-label">City <span v-if="!viewMode" class="text-danger">*</span></label>
              <input v-if="!viewMode" type="text" class="form-control" :class="{ 'is-invalid': errors.city }" v-model="city" placeholder="Enter city" />
              <p v-else class="form-control-plaintext mb-0">{{ city || '-' }}</p>
              <div class="invalid-feedback" v-if="errors.city">{{ errors.city[0] }}</div>
            </div>

            <!-- Country -->
            <div class="col-md-3 mb-3">
              <label class="form-label">Country</label>
              <vue-select v-if="!viewMode" :options="countries" label="name" v-model="country" @update:modelValue="onCountrySelect" placeholder="Select Country" />
              <p v-else class="form-control-plaintext mb-0">{{ country?.name || '-' }}</p>
              <div class="invalid-feedback d-block" v-if="errors.country">{{ errors.country[0] }}</div>
            </div>

            <!-- State -->
            <div class="col-md-3 mb-3">
              <label class="form-label">State</label>
              <vue-select v-if="!viewMode" :options="states" label="name" v-model="state" placeholder="Select State" />
              <p v-else class="form-control-plaintext mb-0">{{ state?.name || '-' }}</p>
              <div class="invalid-feedback d-block" v-if="errors.state">{{ errors.state[0] }}</div>
            </div>

          <template v-if="form.delivery_status === 'dispatched'">
                <div class="col-md-4 mb-3">
                  <label class="form-label">Transport Person</label>
                  <p class="form-control-plaintext mb-0">{{ form.transport_person_name || '-' }}</p>
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">Transport Phone</label>
                  <p class="form-control-plaintext mb-0">{{ form.transport_phone_number || '-' }}</p>
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">Vehicle No</label>
                  <p class="form-control-plaintext mb-0">{{ form.transport_vehicle_number || '-' }}</p>
                </div>
              </template>

        </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">{{ viewMode ? 'Close' : 'Cancel' }}</button>
          <button v-if="!viewMode" type="button" class="btn btn-primary" @click="submitForm()" :disabled="submitting">
            {{ submitting ? 'Saving...' : (isEdit ? 'Update' : 'Save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Confirmation Modal -->
  <div class="modal fade" id="customer_dispatch_delete_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center py-4">
          <div class="mb-3">
            <i class="ti ti-trash text-danger" style="font-size: 40px;"></i>
          </div>
          <h5>Delete Dispatch</h5>
          <p class="text-muted mb-0">Are you sure you want to delete dispatch for <strong>{{ deleteRow?.name }}</strong> ({{ deleteRow?.file_number }})?</p>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-danger" @click="deleteDispatch()">Delete</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Update Status Modal -->
<div class="modal fade" id="customer_dispatch_status_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
      
      <!-- Header -->
      <div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f);padding:15px 20px;border:none;">
        <div class="d-flex align-items-center gap-2">
          <div style="width:32px;height:32px;background:rgba(255,255,255,.15);border-radius:8px;display:flex;align-items:center;justify-content:center;">
            <i class="ti ti-refresh" style="color:#fff;font-size:15px;"></i>
          </div>
          <div>
            <h5 class="modal-title" style="font-size:14px;font-weight:700;color:#fff;margin:0;">Update Delivery Status</h5>
            <div style="font-size:11px;color:#94a3b8;">Select the new status for this dispatch</div>
          </div>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" style="filter:invert(1);opacity:.6;"></button>
      </div>

      <!-- Body -->
      <div class="modal-body" style="padding:20px;">
        <div class="mb-3">
          <label class="form-label" style="font-size:11px;font-weight:600;color:#475569;">
            Delivery Status <span class="text-danger">*</span>
          </label>
          <select class="form-select" v-model="statusForm.delivery_status" style="border:1.5px solid #e2e8f0;border-radius:8px;font-size:13px;">
            <option value="" disabled selected>-- Select Status --</option>
            <option v-if="statusForm.current_status === 'pending'" value="ready_for_dispatch">Ready for Dispatch</option>
            <option v-if="statusForm.current_status === 'approved'" value="ready_for_dispatch">Ready for Dispatch</option>
            <option v-if="statusForm.current_status === 'ready_for_dispatch'" value="dispatched">Dispatched</option>
            <option v-if="statusForm.current_status === 'ready_for_dispatch'" value="partial_dispatched">Partial Dispatched</option>
            <option v-if="statusForm.current_status === 'partial_dispatched'" value="dispatched">Dispatched</option>
          </select>
        </div>


        <template v-if="statusForm.delivery_status === 'dispatched'">

            <div class="mb-3 mt-2">
              <div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;color:#94a3b8;border-bottom:1px solid #e2e8f0;padding-bottom:8px;">
                Transport Details
              </div>
            </div>

          <div class="mb-3">
            <label class="form-label" style="font-size:11px;font-weight:600;color:#475569;">Person Name</label>
            <input type="text" class="form-control" v-model="statusForm.transport_person_name" placeholder="Enter person name" style="border:1.5px solid #e2e8f0;border-radius:8px;font-size:13px;" />
             <small class="text-danger" v-if="errors.transport_person_name">{{ errors.transport_person_name[0] }}</small>
          </div>
          <div class="mb-3">
            <label class="form-label" style="font-size:11px;font-weight:600;color:#475569;">Phone</label>
            <input type="tel" class="form-control" v-model="statusForm.transport_phone_number" placeholder="Enter phone number" style="border:1.5px solid #e2e8f0;border-radius:8px;font-size:13px;" />
            <small class="text-danger" v-if="errors.transport_phone_number">{{ errors.transport_phone_number[0] }}</small>
          </div>
          <div class="mb-0">
            <label class="form-label" style="font-size:11px;font-weight:600;color:#475569;">Vehicle No</label>
            <input type="text" class="form-control" v-model="statusForm.transport_vehicle_number" placeholder="Enter vehicle number" style="border:1.5px solid #e2e8f0;border-radius:8px;font-size:13px;" />
            <small class="text-danger" v-if="errors.transport_vehicle_number">{{ errors.transport_vehicle_number[0] }}</small>
          </div>
        </template>
      </div>

      <!-- Footer -->
      <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 20px;gap:8px;">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" style="border-radius:8px;font-size:12px;font-weight:600;">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submitStatus()" :disabled="submittingStatus" style="border-radius:8px;font-size:12px;font-weight:600;">
          <i class="ti ti-device-floppy me-1"></i>
          {{ submittingStatus ? 'Saving...' : 'Save Status' }}
        </button>
      </div>

    </div>
  </div>
</div>

<!-- Assign Installation Person Modal -->
<div class="modal fade" id="assign_installer_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="border:none;border-radius:16px;overflow:hidden;">
      <div class="modal-header" style="background:linear-gradient(135deg,#0f172a,#1e3a5f);padding:15px 20px;border:none;">
        <div class="d-flex align-items-center gap-2">
          <div style="width:32px;height:32px;background:rgba(255,255,255,.15);border-radius:8px;display:flex;align-items:center;justify-content:center;">
            <i class="ti ti-user-plus" style="color:#fff;font-size:15px;"></i>
          </div>
          <div>
            <h5 class="modal-title" style="font-size:14px;font-weight:700;color:#fff;margin:0;">Assign Installation Person</h5>
            <div style="font-size:11px;color:#94a3b8;">Select person to assign this dispatch</div>
          </div>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" style="filter:invert(1);opacity:.6;"></button>
      </div>
      <div class="modal-body" style="padding:20px;">
        <div class="mb-3">
          <label class="form-label" style="font-size:11px;font-weight:600;color:#475569;">
            Installation Person <span class="text-danger">*</span>
          </label>
          <select class="form-select" v-model="installerForm.installation_person_id" style="border:1.5px solid #e2e8f0;border-radius:8px;font-size:13px;">
            <option value="">-- Select Person --</option>
            <option v-for="p in installationPersons" :key="p.id" :value="p.id">
              {{ p.user?.name }}
            </option>
          </select>
          <small class="text-danger" v-if="errors.installation_person_id">{{ errors.installation_person_id[0] }}</small>
        </div>
      </div>
      <div class="modal-footer" style="border-top:1px solid #e2e8f0;padding:11px 20px;gap:8px;">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" style="border-radius:8px;font-size:12px;font-weight:600;">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submitAssignInstaller()" style="border-radius:8px;font-size:12px;font-weight:600;">
          <i class="ti ti-user-check me-1"></i> Assign
        </button>
      </div>
    </div>
  </div>
</div>

</template>